import type { Theme } from "@mui/material/styles"
import type { OrderDetailsStatusSemanticColor } from "@/domain/order/order-details.model"
import type { PaymentPresentationVariant } from "@/domain/order/order-details-payment-presentation"

export function orderDetailsSemanticAccent(theme: Theme, color: OrderDetailsStatusSemanticColor): string {
  const map: Record<OrderDetailsStatusSemanticColor, string> = {
    blue: theme.palette.info.main,
    orange: theme.palette.warning.main,
    green: theme.palette.success.main,
    gray: theme.palette.grey[500],
    red: theme.palette.error.main,
    yellow: theme.palette.warning.light,
    purple: theme.palette.secondary.main,
  }
  return map[color] ?? theme.palette.grey[500]
}

export function paymentPresentationAccent(
  theme: Pick<Theme, "palette">,
  variant: PaymentPresentationVariant
): string {
  if (variant === "success") return theme.palette.success.main
  if (variant === "error") return theme.palette.error.main
  if (variant === "warning") return theme.palette.warning.main
  return theme.palette.text.secondary
}

export function paymentPresentationChipSx(
  theme: Pick<Theme, "palette">,
  variant: PaymentPresentationVariant
) {
  const color = paymentPresentationAccent(theme, variant)
  return { color, borderColor: color }
}

export function paymentStatusAccent(theme: Theme, paymentStatusUpper: string): string {
  const u = paymentStatusUpper.toUpperCase()
  if (!u || u === "UNKNOWN") return theme.palette.text.secondary
  if (/FAIL|VOID|CANCEL|EXPIR|ERROR|DECLIN/i.test(u)) return theme.palette.error.main
  if (/PEND|AUTH|PROCESS|REQUIRE|CREAT/i.test(u)) return theme.palette.warning.main
  if (/CAPTURE|PAID|SUCCESS|COMPLET|SETTL/i.test(u)) return theme.palette.success.main
  return theme.palette.info.main
}
